var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12842_4001)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12842_4001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8904 0.775172C14.8555 0.349051 14.5123 0 14.0832 0C13.6541 0 13.3109 0.349051 13.276 0.775172C12.9022 5.29813 9.29664 8.90368 4.77517 9.276C4.3476 9.31091 4 9.65558 4 10.0832C4 10.5122 4.3476 10.8555 4.77517 10.8918C9.29701 11.2642 12.9022 14.8697 13.276 19.3912C13.3109 19.8188 13.6541 20.1678 14.0832 20.1678C14.5123 20.1678 14.8555 19.8188 14.8904 19.3912C15.2642 14.8693 18.8698 11.2642 23.3912 10.8918C23.8188 10.8555 24.1664 10.5123 24.1664 10.0832C24.1664 9.65562 23.8188 9.31093 23.3912 9.276C18.8694 8.90368 15.2642 5.29813 14.8904 0.775172Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12842_4001)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12842_4001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.9309,
    cy: 6.32945,
    rx: 6.51561,
    ry: 6.32945,
    fill: "#FF62FC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_12842_4001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.1945,
    cy: 4.19448,
    r: 7.02651,
    fill: "#4A03FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_12842_4001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.2897,
    cy: 8.26427,
    r: 6.70178,
    fill: "#2AD8FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_12842_4001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.7068,
    cy: 17.3125,
    r: 6.51561,
    fill: "#AFF75C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_12842_4001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.32945,
    cy: 14.6836,
    rx: 6.32945,
    ry: 6.51561,
    fill: "#FF5151"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_12842_4001)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.191,
    cy: 17.3125,
    rx: 6.70178,
    ry: 6.51561,
    fill: "#FFD311"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12842_4001",
    x: 0,
    y: 0,
    width: 28.1665,
    height: 28.168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.713726 0 0 0 0 0.713726 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12842_4001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12842_4001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12842_4001",
    x: -7.0082,
    y: -5.42348,
    width: 23.8782,
    height: 23.5052,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71174,
    result: "effect1_foregroundBlur_12842_4001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_12842_4001",
    x: 0.46998,
    y: -10.53,
    width: 29.449,
    height: 29.4487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.84899,
    result: "effect1_foregroundBlur_12842_4001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_12842_4001",
    x: 7.16441,
    y: -3.86098,
    width: 24.2505,
    height: 24.2513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71174,
    result: "effect1_foregroundBlur_12842_4001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_12842_4001",
    x: 6.76768,
    y: 5.3734,
    width: 23.8782,
    height: 23.8782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71174,
    result: "effect1_foregroundBlur_12842_4001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_12842_4001",
    x: -3.42348,
    y: 2.74449,
    width: 23.5059,
    height: 23.8782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71174,
    result: "effect1_foregroundBlur_12842_4001"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_12842_4001",
    x: 0.0657787,
    y: 5.3734,
    width: 24.2505,
    height: 23.8782,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71174,
    result: "effect1_foregroundBlur_12842_4001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.ad70ab8e99c01f3396ad00e19daeccf9.svg";
export { ForwardRef as ReactComponent };